import React, { useEffect, useMemo, useState } from 'react';
import { styled } from '@mui/system';
import i18n from 'i18next';
import brasilFlag from './assets/brasil.png';
import euaFlag from './assets/eua.png';
import { Menu, MenuItem, IconButton, Box } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const FlagButton = styled('div')({
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  cursor: 'pointer',
  margin: '0 5px',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.1)',
  },
});

const LanguageSettings = () => {
  const availableLanguages = useMemo(
    () => [
      { code: 'en', name: 'English', flag: euaFlag },
      { code: 'pt', name: 'Português', flag: brasilFlag },
    ],
    []
  );

  const [selectedLanguage, setSelectedLanguage] = useState(availableLanguages[0]);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenTranslate = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseTranslate = () => {
    setAnchorEl(null);
  };

  const handleSelectLanguage = (language) => {
    setSelectedLanguage(language);
    i18n.changeLanguage(language.code);

    if (!sessionStorage.getItem('lang') || sessionStorage.getItem('lang') !== language.code) {
      sessionStorage.setItem('lang', language.code);
    }

    handleCloseTranslate();
  };

  useEffect(() => {
    const currentLanguage = localStorage.getItem('i18nextLng');
    const currentSelectedLanguage = availableLanguages.find((lang) => lang.code === currentLanguage);

    if (!currentSelectedLanguage) {
      sessionStorage.setItem('lang', 'pt');
    } else {
      setSelectedLanguage(currentSelectedLanguage);
    }
  }, [availableLanguages]);

  return (
    <Box sx={{ display: 'inline-block', position: 'relative' }}>
      <IconButton
        onClick={handleOpenTranslate}
        id="header-translate-button"
        aria-label="Select Language"
        aria-controls="language-menu"
        aria-haspopup="true"
      >
        <FlagButton style={{ backgroundImage: `url(${selectedLanguage.flag})` }} />
        <ArrowDropDownIcon />
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseTranslate}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {availableLanguages.map((language) => (
          <MenuItem key={language.code} onClick={() => handleSelectLanguage(language)}>
            <FlagButton style={{ backgroundImage: `url(${language.flag})` }} />
            {language.name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSettings;


